// The single cross-surface Unleash stickiness anchor. Shared verbatim with
// aha-pricing (which mints the same-named cookie on the pricing page) so one
// human resolves to one variant on every surface. Format: uuid v4, dashes kept.
//
// Kept in a dependency-free module so both unleash.js and unleashSession.js read
// the anchor without dragging the cookie service / Vuex store into the
// light-weight unleash.js bootstrap import graph.
export const UNLEASH_SESSION_COOKIE = 'aha_unleash_session'

// Read with the RAW key, symmetric with the write path (cookie.setRootDomainCookie
// writes the raw key): cookie.getValue() would apply transformKey and read
// `eu-aha_unleash_session` in the EU region, re-minting on every load.
export const readRawSessionCookie = () => {
  if (typeof document === 'undefined') return undefined
  const match = document.cookie.match(new RegExp(`(?:^|; )${UNLEASH_SESSION_COOKIE}=([^;]*)`))
  if (!match) return undefined
  // decodeURIComponent throws URIError on a malformed cookie; fall back to the
  // raw value so a bad cookie can never crash bootstrap.
  try {
    return decodeURIComponent(match[1])
  } catch (error) {
    return match[1]
  }
}
